import { render, staticRenderFns } from "./fichajes_hoy.vue?vue&type=template&id=4c8a01d1&scoped=true&"
import script from "./fichajes_hoy.vue?vue&type=script&lang=ts&"
export * from "./fichajes_hoy.vue?vue&type=script&lang=ts&"
import style0 from "./fichajes_hoy.vue?vue&type=style&index=0&id=4c8a01d1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8a01d1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VIcon,VRow})
